import type { Currency } from '@core/pricing-types';
import type { BillingPlan, BillingPlanTier } from '@core/products-types';

export const getProduct = (
  codename: BillingPlanTier,
  currency: Currency,
  products: BillingPlan[] | undefined,
  excludeCustom: boolean = false,
): BillingPlan | undefined =>
  (products || [])
    .filter(p => {
      if (p.tier === codename && p.currency === currency) {
        if (excludeCustom) return !p.custom;
        return true;
      }

      return false;
    })
    .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
    .shift();
